// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__mFszg","bounce":"Modal_bounce__vX4VM","overlay":"Modal_overlay__hEZVw","Wrapper":"Modal_Wrapper__EnQPr"};